import { render, staticRenderFns } from "./PartnerBankingData.vue?vue&type=template&id=4894d846"
import script from "./PartnerBankingData.vue?vue&type=script&lang=js"
export * from "./PartnerBankingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports